import { isUseFilterDefault } from "../../../utils/user"

export const volumeFiltersDefault = {
  BusinessUnitIds: [],
  SupplierIds: [],
  MaterialsNumber: [],
  PendingItems: false,
  CoordinationId: '',
  MaterialGroupIds: [],
  CollectDateMin: '',
  CollectDateMax: '',
  DeliveryDateMin: '',
  DeliveryDateMax: '',
  DeliveryTimeMin: '',
  DeliveryTimeMax: '',
  Status: [],
  UseFilterDefault: isUseFilterDefault(),
  _page: 0,
  _size: 50
}
